<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->


<template>
	<div>

<!--		<div v-if="isDataLoading" v-loading="isDataLoading" element-loading-text="Loading Programs..." class="empty-loading-placeholder">-->

<!--		</div>-->
		<div>
			<div class="col px-0">
				<div class="px-3 pb-4">
					<h4 style="font-weight: 500" class="mb-4">Connect your calendar</h4>
					<p>Connect your calendar to automatically check for busy times and to add new sessions as people schedule them.</p>
					<div class="text-muted">You'll be able to connect multiple calendars later on.</div>
				</div>


				<div v-if="showConnectLink" style="text-align: center">
					<div>
						<a :href="redirectUrl" class="font-size-5" target="_top">Click to connect calendar</a>
					</div>
					<div>
						<qw-button @click="() => showConnectLink = false">Back</qw-button>
					</div>
				</div>

				<div class="col" v-else>

					<div>
						<hr class="m-0"/>
						<div class="clickable hover row py-3 integration-row" @click.prevent="onGoogleClicked">
							<div class="col-1 m-0 p-0 vertical-center">
								<img :src="require('@/assets/images/calendar/google.png')" style="width: 100%;"/>
							</div>
							<div class="col">
								<h5 style="font-weight: 600">Google Calendar</h5>
								<span>Google Calendar, G Suite</span>
							</div>
							<div class="col-1 vertical-center">
								<i class="fontello  icon-angle-right"></i>
							</div>
						</div>
						<hr class="m-0"/>
						<div class="clickable hover row py-3 integration-row" @click.prevent="onOutlook365Clicked">
							<div class="col-1 m-0 p-0 vertical-center">
								<img :src="require('@/assets/images/calendar/office-365-icon.png')" style="width: 100%;"/>
							</div>
							<div class="col">
								<h5 style="font-weight: 600">Office 365 Calendar</h5>
								<span>Outlook.com, Office 365, hotmail or live.com calendar</span>
							</div>
							<div class="col-1 vertical-center">
								<i class="fontello  icon-angle-right"></i>
							</div>
						</div>
<!--						<hr class="m-0"/>-->

<!--						<div class="row">-->
<!--							<a class="clickable-item" @click.prevent="onSkipClicked">-->
<!--								<div class="col-1">-->

<!--								</div>-->
<!--								<div class="col">-->
<!--									<h5 style="font-weight: 600">Skip calendar integration</h5>-->
<!--									<span>Not recommended - this can lead to scheduling conflicts</span>-->
<!--								</div>-->
<!--								<div class="col-1">-->

<!--								</div>-->
<!--							</a>-->

<!--						</div>-->
					</div>

				</div>


			</div>

		</div>
		<LoadingIndicator/>

	</div>
</template>

<script>

	import WizardBaseStep from "./WizardBaseStep"
	import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
	import {CalendarTypeEnum} from "@shared/integrations/calendar/CalendarTypeEnum";


	export default {
		components: {LoadingIndicator},
		extends: WizardBaseStep,
		props: {
			forceStartConnectCalendarType: String,
		},
		data() {
			return {

				step: 1,
				stepCount: 2,
				showConnectLink: false,
				redirectUrl: null,
			};
		},
		computed:{
			wizardStepPercentage(){
				return this.step / this.stepCount * 100
			}
		},
		mounted () {
			switch (this.forceStartConnectCalendarType){
				case CalendarTypeEnum.GOOGLE:
					return this.onGoogleClicked()
				case CalendarTypeEnum.OUTLOOK:
					return this.onOutlook365Clicked()
				case CalendarTypeEnum.ICAL:
					return this.onICalClicked()
			}
		},
		methods: {

			async onGoogleClicked(){
				this.progressDataLoading()
				let thisUrl = window.location.href
				let redirectUrl = await this.handleAsyncNonBlocking(this.$dataManager.apiPostGCalendarAuthStart({uid: this.userProfile.id, destination: thisUrl}))
				if(redirectUrl){
					window.location.href = redirectUrl
					// this.redirectToOuter(redirectUrl)
				} else {
					this.hideProgressFail()
				}
			},

			async onOutlook365Clicked(){
				this.progressDataLoading()
				let thisUrl = window.location.href
				let redirectUrl = await this.handleAsyncNonBlocking(this.$dataManager.apiPostOutlook365AuthStart({uid: this.userProfile.id, destination: thisUrl}))
				if(redirectUrl){
					window.location.href = redirectUrl
					// this.redirectToOuter(redirectUrl)
				} else {
					this.hideProgressFail()
				}
			},

			async onICalClicked(){

			},


			redirectToOuter(redirectUrl) {
				let res
				try{
					res = window.open(redirectUrl, "_top")
				} catch (e){
					console.error(e)
				}

				if(!res){
					this.hideProgress()
					this.showConnectLink = true
					this.redirectUrl = redirectUrl
				}
			}
		},

	}
</script>

<style src="../Scheduler.scss" lang="scss" scoped/>
